import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from 'src/app/services/app-config.service';
import { IAppConfig } from 'src/app/shared/interfaces/app-config';
import { NursingReferralList } from '../interfaces/nursing-referrals-list';
import { catchError, Observable } from 'rxjs';
import { handleError } from 'src/app/shared/functions/error-handler';
import { assertTrustedUrl } from 'src/app/shared/functions/validate-url';
import { NursingReferralRequest } from '../models/nursing-referral-request.model';
import { NursingStudentData } from '../interfaces/nursing-student-data';
import { INursingReferralStatus } from 'src/app/shared/interfaces/nursing-status';
import { IPayloadDocUpload } from '../interfaces/document-upload-payload';

@Injectable({
  providedIn: 'root',
})
export class NursingReferralService {
  config: IAppConfig;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.config = this.appConfigService.getConfig();
  }

  //   dataList = [
  //   {
  //     "caseActionSk": "d4d54dc8-3a0e-412c-850b-63e86716e2a8",
  //     "studentName": "string",
  //     "nycId": "925219313",
  //     "grade": 0,
  //     "studentDOB": "string",
  //     "schoolDBN": "string",
  //     "schoolName": "string",
  //     "schoolBorough": "string",
  //     "schoolDistrict": "string",
  //     "schoolCSE": "string",
  //     "referralType": "",
  //     "statusName": "Draft",
  //     "lastModified": "2025-08-28T23:24:02.187",
  //     "daysago": "0 days ago"
  //   },
  //   {
  //     "caseActionSk": "d4d54dc8-3a0e-412c-850b-63e86716e2a8",
  //     "studentName": "string",
  //     "nycId": "925219313",
  //     "grade": 0,
  //     "studentDOB": "string",
  //     "schoolDBN": "string",
  //     "schoolName": "string",
  //     "schoolBorough": "string",
  //     "schoolDistrict": "string",
  //     "schoolCSE": "string",
  //     "referralType": "",
  //     "statusName": "Draft",
  //     "lastModified": "2025-08-20T15:14:56.223",
  //     "daysago": "8 days ago"
  //   }
  // ];

  public referralsList(): Observable<NursingReferralList[]> {
    return this.http
      .get<NursingReferralList[]>(`${this.config.apiUrl}/NursingReferral/List`)
      .pipe(catchError(handleError));
  }

  public get(caseActionSk: string): Observable<NursingReferralRequest> {
    const url = assertTrustedUrl(
      `${this.config.apiUrl}/NursingReferral/${encodeURIComponent(caseActionSk)}`,
      this.config.apiUrl
    );
    return this.http
      .get<NursingReferralRequest>(url)
      .pipe(catchError(handleError));
  }

  public getStudentData(nycId: string): Observable<NursingStudentData> {
    const url = assertTrustedUrl(
      `${this.config.apiUrl}/NursingReferral/studentDetailes/${encodeURIComponent(nycId)}`,
      this.config.apiUrl
    );
    return this.http
      .get<NursingStudentData>(url)
      .pipe(catchError(handleError));
  }

  public removeNursingReferral(caseActionSk: string): Observable<boolean> {
    const url = assertTrustedUrl(
      `${this.config.apiUrl}/NursingReferral/DeleteNursingReferral/${encodeURIComponent(caseActionSk)}`,
      this.config.apiUrl
    );
    return this.http
      .delete<boolean>(url)
      .pipe(catchError(handleError));
  }
  public AddNursingReferral(payload: any): Observable<NursingReferralRequest> {
    return this.http
      .post<NursingReferralRequest>(
        `${this.config.apiUrl}/NursingReferral/AddNursingReferral`,
        payload
      )
      .pipe(catchError(handleError));
  }
  public getStatus(iepFormSk: string): Observable<INursingReferralStatus> {
    const url = assertTrustedUrl(
      `${this.config.apiUrl}/NursingReferral/Status/${encodeURIComponent(iepFormSk)}`,
      this.config.apiUrl
    );
    return this.http
      .get<INursingReferralStatus>(url)
      .pipe(catchError(handleError));
  }

  updateDocumentMetaData(payload: IPayloadDocUpload[]): Observable<true> {
    return this.http
      .post<true>(`${this.config.apiUrl}/NursingReferral/updateDocumentMetadata`, payload)
      .pipe(catchError(handleError));
  }

  cancelReferral(payload: { caseactionSK:string, isSummaryNursingReferral: boolean }): Observable<boolean> {
    return this.http
      .put<boolean>(
        `${this.config.apiUrl}/NursingReferral/CancelNursingReferral`,
        payload
      )
      .pipe(catchError(handleError));
  }
}
